
// region external libs
import $ from "jquery"
import "plugins/jquery_plugins/bootstrap-carousel"
// endregion external libs

// region constants
const INIT_COMPLETE_CLASS = "js-init-done"

interface Selector {
  carousel:             string
  images:               string
  slide_to_prev_button: string
  slide_to_next_button: string
}
interface InputSelector {
  carousel?:             string
  images?:               string
  slide_to_prev_button?: string
  slide_to_next_button?: string
}
const default_selector = {
  carousel:             ".cell--floor-plan-images--carousel",
  images:               ".cell--floor-plan-images--carousel--image",
  slide_to_prev_button: ".cell--floor-plan-image--carousel__slide-prev-btn",
  slide_to_next_button: ".cell--floor-plan-image--carousel__slide-next-btn",
}
// endregion constants


class FloorPlanImagesCarousel {
  private selector: Selector

  private $carousel: JQuery
  private $slide_to_prev_button: JQuery
  private $slide_to_next_button: JQuery

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, default_selector, selector)

    this.$carousel = $(this.selector.carousel)

    this.$slide_to_prev_button = this.$carousel.find(this.selector.slide_to_prev_button)
    this.$slide_to_next_button = this.$carousel.find(this.selector.slide_to_next_button)

    this.bind_action()
    this.created()
  }
  protected bind_action(){
    if (this.$carousel.hasClass(INIT_COMPLETE_CLASS)){
      return this
    }

    this.$carousel.carousel("pause")

    this.$carousel.addClass(INIT_COMPLETE_CLASS)

    this.$slide_to_prev_button.on("click", (e) => {
      // Might be an anchor with hash in href
      e.preventDefault()

      this.$carousel.carousel("prev")
    })
    this.$slide_to_next_button.on("click", (e) => {
      // Might be an anchor with hash in href
      e.preventDefault()

      this.$carousel.carousel("next")
    })

    this.$carousel.on("slid.bs.carousel", () => {
      this.process_active_buttons()
    })

    return this
  }

  protected created(){
    this.process_active_buttons()
  }

  protected process_active_buttons(){
    if (this.$carousel.find(".item:first").hasClass("active")) {
      this.$slide_to_prev_button.hide()
      this.$slide_to_next_button.show()
    }else if (this.$carousel.find(".item:last").hasClass("active")) {
      this.$slide_to_prev_button.show()
      this.$slide_to_next_button.hide()
    }else{
      this.$slide_to_prev_button.show()
      this.$slide_to_next_button.show()
    }
  }
}

const Factory = {
  create(selector?: InputSelector){
    return new FloorPlanImagesCarousel(selector)
  },
}

// region export
export {
  Factory,
  Factory as default,
}
// endregion export
